import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Landing from "@/pages/Landing";
import NotFound from "@/pages/NotFound";
const GoRedirect = lazy(() => import("@/pages/GoRedirect"));

// Lazy-load non-critical routes to shrink the landing bundle
const Designer = lazy(() => import("@/pages/Designer"));
const Auth = lazy(() => import("@/pages/Auth"));
const OAuthCallback = lazy(() => import("@/pages/OAuthCallback"));
const Projects = lazy(() => import("@/pages/Projects"));
const Pricing = lazy(() => import("@/pages/Pricing"));
const Settings = lazy(() => import("@/pages/Settings"));
const Admin = lazy(() => import("@/pages/Admin"));
const AdminAnalytics = lazy(() => import("@/pages/AdminAnalytics"));
const ApiDocumentation = lazy(() => import("@/pages/ApiDocumentation"));
const Notifications = lazy(() => import("@/pages/Notifications"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const CcpaNotice = lazy(() => import("@/pages/CcpaNotice"));
const CookiePolicy = lazy(() => import("@/pages/CookiePolicy"));
const CookieSettings = lazy(() => import("@/pages/CookieSettings"));
const ComplianceAdmin = lazy(() => import("@/pages/ComplianceAdmin"));
const SystemStatus = lazy(() => import("@/pages/SystemStatus"));
const Support = lazy(() => import("@/pages/Support"));
const PaymentReturn = lazy(() => import("@/pages/PaymentReturn"));
const PaymentSuccess = lazy(() => import("@/pages/PaymentSuccess"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const Explore = lazy(() => import("@/pages/Explore"));
const StylesIndex = lazy(() => import("@/pages/StylesIndex"));
const StyleCategory = lazy(() => import("@/pages/StyleCategory"));
const StyleDetail = lazy(() => import("@/pages/StyleDetail"));
const RoomsIndex = lazy(() => import("@/pages/RoomsIndex"));
const RoomDetail = lazy(() => import("@/pages/RoomDetail"));
const RegionLanding = lazy(() => import("@/pages/landings/RegionLanding"));
const FeedbackAndTestimonials = lazy(() => import("@/pages/FeedbackAndTestimonials"));

/**
 * Web-specific routing configuration
 * Landing + NotFound load eagerly; everything else is code-split.
 */
export const WebRouter = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/oauth-callback" element={<OAuthCallback />} />
        <Route path="/designer" element={<Designer />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/analytics" element={<AdminAnalytics />} />
        <Route path="/admin/api-docs" element={<ApiDocumentation />} />
        <Route path="/admin/compliance" element={<ComplianceAdmin />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/ccpa-notice" element={<CcpaNotice />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/cookie-settings" element={<CookieSettings />} />
        <Route path="/status" element={<SystemStatus />} />
        <Route path="/support" element={<Support />} />
        <Route path="/payment-return" element={<PaymentReturn />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/go/:to" element={<GoRedirect />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/styles" element={<StylesIndex />} />
        <Route path="/styles/:categoryId" element={<StyleCategory />} />
        <Route path="/styles/:categoryId/:styleSlug" element={<StyleDetail />} />
        <Route path="/rooms" element={<RoomsIndex />} />
        <Route path="/rooms/:roomSlug" element={<RoomDetail />} />
        {/* Region & topic SEO landing pages */}
        <Route path="/us" element={<RegionLanding slug="us" />} />
        <Route path="/uk" element={<RegionLanding slug="uk" />} />
        <Route path="/eu" element={<RegionLanding slug="eu" />} />
        <Route path="/italy" element={<RegionLanding slug="italy" />} />
        <Route path="/france" element={<RegionLanding slug="france" />} />
        <Route path="/apartment-makeover" element={<RegionLanding slug="apartment-makeover" />} />
        <Route path="/living-room-design" element={<RegionLanding slug="living-room-design" />} />
        <Route path="/bedroom-design" element={<RegionLanding slug="bedroom-design" />} />
        <Route path="/ai-interior-design-app" element={<RegionLanding slug="ai-interior-design-app" />} />
        <Route path="/room-refresh" element={<RegionLanding slug="room-refresh" />} />
        <Route path="/feedback-and-testimonials" element={<FeedbackAndTestimonials />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};
